// extracted by mini-css-extract-plugin
export default {"Tagline":"Hero_Tagline__Qktri"};